import React from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import Calendar_staff_details_listing from "assets/images/calendar_staff_details_listing.svg";
import Reports_To_staff_listing from "assets/images/Reports_To_staff_listing.svg";
import offices_icon_staff_listing from "assets/images/offices_icon_staff_listing.svg";
import { StatusCard } from ".";
import moment from "moment";
import styles from "../../AddStaff/AddStaff.module.scss";
function AssignedOfficeModal({
  t,
  isModalOpen,
  setIsModalOpen,
  officeList,
  sikkaProviderId,
  globalStaffPage,
}) {
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className={"modal-dialog-centered modal-width-660"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => setIsModalOpen(false)}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">Assigned Office(s)</span>
          </Text>
          <div className={styles["modal-view-lists"]}>
            {officeList.map((officeFirstData) => {
              return (
                <div className={" border-bottom pt-2"}>
                  <div className="profile d-flex align-items-center justify-content-start ps-xs cfs-xs mb-2">
                    <img src={offices_icon_staff_listing} alt="staff" />
                    <span className="ml-2">
                      {officeFirstData?.officeName +
                        ` (${officeFirstData?.designationName})`}{" "}
                    </span>
                  </div>
                  <div className="profile d-flex align-items-center justify-content-start ps-xs cfs-xs mb-2">
                    <img src={Reports_To_staff_listing} alt="staff" />
                    <span className="ml-2">Reports To: </span>
                    <b className="text-dark ml-2">
                      {officeFirstData?.reportToName || "--"}
                    </b>
                  </div>
                  <div className="profile d-flex align-items-center justify-content-start ps-xs cfs-xs mb-2">
                    <img src={Calendar_staff_details_listing} alt="staff" />
                    <span className="ml-2">Employment Date: </span>
                    <b className="text-dark ml-2">
                      {officeFirstData?.employmentDate
                        ? moment(officeFirstData?.employmentDate).format(
                            "MMM DD,YYYY"
                          )
                        : "--"}
                    </b>
                  </div>
                  <StatusCard
                    t={t}
                    type={officeFirstData?.type}
                    timeSheet={officeFirstData?.timeSheet}
                    addClass=" ps-xs cfs-xs pb-2"
                    spanClass="ml-2"
                    globalStaffPage={globalStaffPage}
                  />
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(AssignedOfficeModal);
